import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';
import type {
  BusinessMapCityDetail,
  BusinessMapCityPoint,
  BusinessMapFilters,
  BusinessMapRankings,
  BusinessMapSummary,
} from './types/business-map';

const request = createAppRequest();
const BASE_PATH = '/bff/zy-crm/business-map';

const normalizeParams = (filters: BusinessMapFilters = {}) => ({ ...filters });

export async function queryBusinessMapOverview(
  filters: BusinessMapFilters,
  options?: ApiRequestOptions,
) {
  return request<BusinessMapSummary>(`${BASE_PATH}/overview`, {
    method: 'GET',
    params: normalizeParams(filters),
    ...(options || {}),
  });
}

export async function queryBusinessMapCityPoints(
  filters: BusinessMapFilters,
  options?: ApiRequestOptions,
) {
  return request<BusinessMapCityPoint[]>(`${BASE_PATH}/city-points`, {
    method: 'GET',
    params: normalizeParams(filters),
    ...(options || {}),
  });
}

export async function queryBusinessMapRankings(
  filters: BusinessMapFilters,
  options?: ApiRequestOptions,
) {
  return request<BusinessMapRankings>(`${BASE_PATH}/rankings`, {
    method: 'GET',
    params: normalizeParams(filters),
    ...(options || {}),
  });
}

export async function queryBusinessMapCityDetail(
  cityCode: string,
  filters: BusinessMapFilters,
  options?: ApiRequestOptions,
) {
  return request<BusinessMapCityDetail>(`${BASE_PATH}/cities/${cityCode}`, {
    method: 'GET',
    params: normalizeParams(filters),
    ...(options || {}),
  });
}
